import { Typography, Grid, TextField, Box, useTheme } from '@mui/material';
import { formatCurrency } from '../closeout/closeoutHelpers';
import { SectionHeader } from './SectionHeader';
import { SignatureSection } from './SignatureSection';

interface ClientAcceptanceProps {
  isEstimateContext: boolean;
  clientInfo: any;
  comprehensiveSummary: any;
  setClientInfo: (info: any) => void;
}

export const ClientAcceptance: React.FC<ClientAcceptanceProps> = ({
  isEstimateContext,
  clientInfo,
  comprehensiveSummary,
  setClientInfo,
}) => {
  const theme = useTheme();

  return (
    <>
      {' '}
      <SectionHeader>
        <Typography variant="subtitle1">Client Acceptance</Typography>
      </SectionHeader>
      <SignatureSection>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" sx={{ mb: 2 }}>
              <strong>{isEstimateContext ? 'Estimate #' : 'PCO #'}:</strong>{' '}
              {clientInfo.changeOrderNumber} • <strong>Final Amount:</strong>{' '}
              {comprehensiveSummary ? formatCurrency(comprehensiveSummary.grandTotal) : '$0.00'}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Name:
            </Typography>
            <TextField
              fullWidth
              size="small"
              value={clientInfo.name}
              onChange={e => setClientInfo({ ...clientInfo, name: e.target.value })}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Date:
            </Typography>
            <TextField
              fullWidth
              size="small"
              type="date"
              value={clientInfo.date}
              onChange={e => setClientInfo({ ...clientInfo, date: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Client Signature:
            </Typography>
            <Box
              sx={{ borderBottom: `1px solid ${theme.palette.divider}`, height: '40px', mb: 1 }}
            />
            <Typography variant="caption" sx={{ fontSize: '10px', fontStyle: 'italic' }}>
              I hereby accept this quotation and authorize the contractor to complete the above
              described work
            </Typography>
          </Grid>
        </Grid>
      </SignatureSection>
    </>
  );
};
